export const OtherInformation = (_) => '';
